import React from 'react'

export const Contacto = () => {
  return (
    <div className='page'>
        <h1 className='heading'>Contacto</h1>

        <h3 style={{ textAlign: 'center' }}>Numero Celular: +56941246169</h3>
        <h3 style={{ textAlign: 'center' }}>Correo: oswaldocristiano99981@gmail.com</h3>

        <form className='contact' action="https://formsubmit.co/oswaldocristiano@gmail.com" method="POST" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '100%' }}>
            <h3>Llena los campos para ponerte en contacto conmigo</h3>
            <input name="Nombre" type="text" placeholder='Nombre' />
            <input name="Asunto" type="text" placeholder='Asunto' />
            <input name="Email" type="text" placeholder='Escriba su email para responderle' />
            <textarea name="Motivos" placeholder='Motivo de contacto' />
            <input type="submit" value="Enviar" />
            <input type="hidden" name="_captcha" value="false"></input>
            <input type="hidden" name="_next" value="http://localhost:3000/emailenviado" target='blank'></input>
        </form>
    </div>
  )
}
